module.exports = __webpack_public_path__ + "static/media/3.abba8d49.jpg";